import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIdCompany } from "../../utils/constantes";
import TextField from "@mui/material/TextField";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props, ref) => {
  const [description, setDescription] = useState(null);
  const [code, setCode] = useState(null);
  const [report, setReport] = useState("");
  const [reportStatus, setReportStatus] = useState(true);
  const [lastMaintenance, setLastMaintenance] = useState(null);
  const [nextMaintenance, setNextMaintenance] = useState(null);
  const [selectedValueEquipment, setSelectedValueEquipment] = useState(null);
  const [selectedValueSector, setSelectedValueSector] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getSkuEquipment();
  }, []);

  useImperativeHandle(ref, () => ({
    addSkuEquipment,
    updateSkuEquipment,
    deleteSkuEquipment,
  }));

  const addSkuEquipment = async () => {
    let data = {
      SKE_description: description,
      SKE_code: code,
      SKE_report: report,
      SKE_reportStatus: reportStatus,
      SKE_status: 1,
      SKE_lastMaintenance: lastMaintenance,
      SKE_nextMaintenance: nextMaintenance,
      SKE_FK_sectorId: selectedValueSector.stR_PK_idSector,
      SKE_FK_equipmentId: selectedValueEquipment.eqP_PK_idEquipment,
      SKE_active: true,
      SKE_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.post("/skuequipment", data);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const updateSkuEquipment = async () => {
    let skuId = null;
    if (selectedValueEquipment != null) {
      skuId = selectedValueEquipment.skE_PK_idSkuEquip;
    }

    let skuequipment = {
      SKE_PK_idSkuEquip: skuId,
      SKE_description: description,
      SKE_lastMaintenance: lastMaintenance,
      SKE_code: code,
      SKE_report: report,
      SKE_reportStatus: reportStatus,
      SKE_nextMaintenance: nextMaintenance,
      SKE_status: 1,
      SKE_FK_sectorId: selectedValueSector.stR_PK_idSector,
      SKE_FK_equipmentId: selectedValueEquipment.eqP_PK_idEquipment,
      SKE_active: true,
      SKE_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.put(
        "/skuequipment/" + props.IdSkuEquip,
        skuequipment
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getSkuEquipment = async () => {
    if (props.IdSkuEquip != null) {
      setIsLoading(false);
      try {
        let response = await blogFetch.get(`/skuequipment/${props.IdSkuEquip}`);
        let data = response.data;

        setDescription(data.skE_description);
        setCode(data.skE_code);
        setReport(data.skE_report);
        setReportStatus(data.skE_statusReport);
        setReportStatus(data.skE_status);
        setLastMaintenance(data.skE_lastMaintenance);
        setNextMaintenance(data.skE_nextMaintenance);
      } catch (error) {
        console.error(error);
        setIsLoading(true);
      }
    } else {
    }
  };

  const getEquipment = async () => {
    try {
      let response = await blogFetch.get("/equipment");
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };
  const getSector = async () => {
    try {
      let response = await blogFetch.get("/sector");
      let data = response.data;
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const handleChangeEquipment = (value) => {
    setSelectedValueEquipment(value);
  };
  const handleChangeSector = (value) => {
    setSelectedValueSector(value);
  };

  const deleteSkuEquipment = async () => {
    let skuId = null;
    if (selectedValueEquipment != null) {
      skuId = selectedValueEquipment.skE_PK_idSkuEquip;
    }

    let skuequipment = {
      SKE_PK_idSkuEquip: skuId,
      SKE_description: description,
      SKE_lastMaintenance: lastMaintenance,
      SKE_code: code,
      SKE_report: report,
      SKE_reportStatus: reportStatus,
      SKE_nextMaintenance: nextMaintenance,
      SKE_status: 1,
      SKE_FK_sectorId: selectedValueSector.stR_PK_idSector,
      SKE_FK_equipmentId: selectedValueEquipment.eqP_PK_idEquipment,
      SKE_active: true,
      SKE_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.delete(
        "/skuequipment/" + props.IdSkuEquip
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <FontAwesomeIcon icon={faSpinner} spin />
        </div>
      ) : (
        <div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Descrição"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <AsyncSelect
              cacheOptions
              defaultOptions
              placeholder="Equipamento"
              value={selectedValueEquipment}
              getOptionLabel={(e) => e.eqP_description}
              getOptionValue={(e) => e.eqP_PK_idEquipment}
              loadOptions={getEquipment}
              onChange={handleChangeEquipment}
            />
          </div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Código"
              variant="outlined"
              fullWidth
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Laudo"
              variant="outlined"
              fullWidth
              value={report}
              onChange={(e) => setReport(e.target.value)}
            />
          </div>
          <div className="radio_container mb-3">
            <h5>Status do Laudo</h5>

            <div className="input_type_question">
              <input
                className="input_cursor"
                type="radio"
                id={"true"}
                name="type"
                value="true"
                checked="checked"
                onChange={() => setReportStatus(true)}
              />
              <label className="input_cursor" htmlFor={"true"}>
                Aprovado
              </label>
            </div>
            <div className="input_type_question">
              <input
                className="input_cursor"
                type="radio"
                id={"false"}
                name="type"
                value="false"
                onChange={() => setReportStatus(false)}
              />
              <label className="input_cursor" htmlFor={"false"}>
                Reprovado
              </label>
            </div>
          </div>
          <div className="mb-3">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Ultima manutenção"
                fullWidth
                format="DD/MM/YYYY"
                className="date-piker"
                onChange={setLastMaintenance}
              />
            </LocalizationProvider>
          </div>
          <div className="mb-3">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Proxima manutenção"
                fullWidth
                format="DD/MM/YYYY"
                className="date-piker"
                onChange={setNextMaintenance}
              />
            </LocalizationProvider>
          </div>
          <AsyncSelect
            cacheOptions
            defaultOptions
            placeholder="Setor"
            value={selectedValueSector}
            getOptionLabel={(e) => e.stR_description}
            getOptionValue={(e) => e.stR_PK_idSector}
            loadOptions={getSector}
            onChange={handleChangeSector}
          />
        </div>
      )}
    </>
  );
});
